import { ItemDetails } from 'components'
import { styled } from '@mui/material'
import { useIsSmallScreen } from 'packages/core'
import { useTranslation } from 'react-i18next'
import { CommonAttributes } from '../../CommonAttributes'
import DomPurify from 'dompurify'
import ReactHtmlParser from 'react-html-parser'
import InfoBoxWithIcon from 'components/common/InfoBoxWithIcon'
const PaddedDiv = styled('div')({
    padding: '0 31px',
})

export const OverviewSection = ({ azureRbacRole }: any) => {
    const { t } = useTranslation()
    const parsedHtml = ReactHtmlParser(
        DomPurify.sanitize(azureRbacRole?.instructions),
    )

    const attributeOrientation = useIsSmallScreen() ? 'vertical' : 'horizontal'

    return (
        <ItemDetails.AttributesContainer
            bottomPadding="0"
            data-ai-explain="Azure RBAC role overview: system type, role type, tenant, description, common policy attributes, and any published instructions."
        >
            <PaddedDiv>
                <ItemDetails.Attribute
                    label={t('Common_SystemType')}
                    value={azureRbacRole.resourceSystemTypeFriendlyName}
                    orientation={attributeOrientation}
                />
                <ItemDetails.Attribute
                    label={t('Common_RoleType')}
                    value={azureRbacRole.roleTypeFriendlyName}
                    orientation={attributeOrientation}
                />

                {azureRbacRole.resourceSystemFriendlyName && (
                    <ItemDetails.Attribute
                        label={t('Common_Tenant')}
                        value={azureRbacRole.resourceSystemFriendlyName}
                        orientation={attributeOrientation}
                    />
                )}

                <ItemDetails.Attribute
                    label={t('Common_Description')}
                    value={azureRbacRole.description}
                    orientation={attributeOrientation}
                />

                <CommonAttributes resource={azureRbacRole} />
                {parsedHtml && parsedHtml.length > 0 && (
                    <InfoBoxWithIcon
                        iconName={'InfoNew'}
                        message={parsedHtml}
                        rootStyles={{
                            width: '100%',
                            marginTop: '2.8rem',
                            marginBottom: '1.8rem',
                        }}
                    />
                )}
            </PaddedDiv>
        </ItemDetails.AttributesContainer>
    )
}
